<script>
    import Mobilebtn from '../mobilebtn.svelte';
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';

    let main;
    let text1;
    let text2;
    let drop;
    let image;
    let button;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(main, text1, [{y: '44.523vw', duration: 1}, {y: '20.523vw', duration: 1}], 3);
        initializeGsapAnimation(main, text2, [{y: '26vw', duration: 1}, {y: '-26vw', duration: 1}], 3);
        initializeGsapAnimation(main, image, [{y: '32.523vw', scale: '1', duration: 1},
            {y: '20.523vw', scale: '1.5', duration: 1}], 3);
        initializeGsapAnimation(main, button, [{y: '0vw', duration: 1}, {y: '-28vw', duration: 1}], 3);
        initializeGsapAnimation(main, drop, [{y: '68vw', duration: 1}, {y: '0vw', duration: 1}], 3);
    }
</script>
<section>
    <div class="maindiv" bind:this={main}>
        <div class="info" bind:this={text1}>
            <p class="text1">Storytellers & Opus</p>
            <p class="heading">SCRIPTWRITERS</p>
        </div>
        <div class="scriptimg" bind:this={image}>
            <img
                src="/images/createmain/script.svg"
                alt=""
                width="100%"
                height="100%"
            />
        </div>
        <div class="text2" bind:this={text2}>
            <p style="padding:5.607vw 0vw 7.710vw 0vw">
                On average, under 0.1% of scripts written within the United
                States ever make it to production. Most of the blood tears
                written by scriptwriters end up in an archive, never to be
                looked up upon again. Months and often years of work is lost.
            </p>
            <p style="font-weight: 700;">
                We are on a mission to change that. If you complete it, it will
                be produced, watched and enjoyed.
            </p>
        </div>
        <div class="btn" bind:this={button}>
            <Mobilebtn width='56.308vw' text='Join Storytellers Governace Council' text2='(Scriptwriter Seat)' state ="Storyteller"/>
        </div>
        <div class="arrowDown" bind:this={drop}>
            <svg width="3.505vw" height="3.505vw" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.82 0.18L3.86 0.18L6.88 5.38L9.88 0.18L12.9 0.18L8.06 8.58L5.68 8.58L0.82 0.18Z" fill="black"/>
                </svg>
                
        </div>
    </div>
</section>

<style>
    .maindiv {
        position: relative;
        font-family: "Orbitron";
        background-color: white;
        z-index: 1;
        overflow: hidden;
        height: max(218vw, 100.92vh);
    }
    p {
        margin: 0;
    }
    .info {
        
        margin-left: 7.009vw;
        z-index: 2;
        /* position: relative; */
    }
    .text1 {
        color: #000000;
        font-weight: 400;
        font-size: 2.336vw;
    }
    .heading {
        color: #a53bd6;
        font-weight: 900;
        font-size: 9.346vw;
    }
    .scriptimg {
        width: 84.346vw;
        height: 72.196vw;
        margin: auto;
        transform: scale(1.5);
        z-index: -1;
        position: relative;
    }
    .text2 {
        color: #000000;
        font-weight: 400;
        font-size: 2.804vw;
        line-height: 3.925vw;
        letter-spacing: 0.09em;
        width: 76.636vw;
        margin: auto;
        text-align: center;
        z-index: 1;
        /* position: relative; */
    }
    .btn{
        position: absolute;
        width: 100%;
        height: 100%;
        bottom: max(11vw, 4.555vh);
        padding-top: 188vw;
        box-sizing: border-box;
    }
    .arrowDown{
        position: absolute;
        width: 3.505vw;
        height: 3.336vw;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
    }
</style>
